__turbopack_context__.v({
  "active": "styles-module__cniSRq__active",
  "btnBlock": "styles-module__cniSRq__btnBlock",
  "mainSearch": "styles-module__cniSRq__mainSearch",
  "mainSearchButton": "styles-module__cniSRq__mainSearchButton",
  "mainSearchTabs": "styles-module__cniSRq__mainSearchTabs",
  "showMap": "styles-module__cniSRq__showMap",
});
